import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { useContext } from "react";
import Home from "./pages/home/Home";
import { SpinnerContext } from "./context/spinnerContext";
import { SpinnerContextType } from "./types/types";
import "./styles/animations.css";
import "./styles/swal.css";

function App() {

    const { spinner } = useContext <SpinnerContextType> (SpinnerContext);

    return (
        <BrowserRouter>
            {spinner}
            <Routes>
                <Route path="/" element={<Home />} />
                <Route path="*" element={<Navigate to="/" />} />
            </Routes>
        </BrowserRouter>
    );
}

export default App;
